import { FeedbackType } from 'shared/store/actions/modal'
import { localStore } from 'shared/utils/storage'

import { RootState } from 'typesafe-actions'

const root = (state: RootState) => state.convo.modal

export const FEEDBACK_LAST_OPEN_KEY = 'feedbackModalLastOpenTime'
export const lastOpenTime = (): number => {
  const lastOpenTime = localStore.get(FEEDBACK_LAST_OPEN_KEY)
  return lastOpenTime ? Number(lastOpenTime) : 0
}

export const feedbackModalOpen = (state: RootState): boolean => root(state).feedbackModal.open
export const feedbackModalTriggeredManually = (state: RootState): boolean =>
  root(state).feedbackModal.manual
export const feedbackModalType = (state: RootState): FeedbackType => {
  return root(state).feedbackModal.type as FeedbackType
}

export const sidebarPreferencesModalOpen = (state: RootState): boolean =>
  root(state).sidebarPreferencesModal.open

export const createSavedRepliesModalOpen = (state: RootState): boolean =>
  root(state).createSavedRepliesModal.open

export const onBoardingV2ModalOpen = (state: RootState): boolean =>
  root(state).onBoardingV2Modal.open

export const onBoardingV2ModalFromHelp = (state: RootState): boolean =>
  root(state).onBoardingV2Modal.fromHelp
